import React from 'react';
import '../Jobs/JobFilters.css';

const TalentFilters = ({ filters, onFilterChange, onClearFilters, onApplyFilters, talentCount, isHorizontal = false, hideHeader = false, onSavePreference = null }) => {
  const hasActiveFilters = () => {
    return (
      (filters.searchQuery && filters.searchQuery.trim() !== '') ||
      (filters.location && filters.location.trim() !== '') ||
      (filters.workType && filters.workType !== '') ||
      (filters.skills && filters.skills.trim() !== '')
    );
  };

  return (
    <div className={`job-filters ${isHorizontal ? 'job-filters-horizontal' : ''}`}>
      {!isHorizontal && !hideHeader && (
        <>
          <div className="job-filters-header">
            <h3>Filters</h3>
            {hasActiveFilters() && (
              <button 
                className="job-filters-clear-btn"
                onClick={onClearFilters}
              >
                Clear all
              </button>
            )}
          </div>

          {talentCount !== null && (
            <div className="job-filters-count">
              {talentCount} {talentCount === 1 ? 'talent' : 'talents'} found
            </div>
          )}
        </>
      )}

      {/* Search Query Filter */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Search</span>
        </label>
        <input
          type="text"
          placeholder="Search for talent, skills, or categories..."
          value={filters.searchQuery || ''}
          onChange={(e) => onFilterChange('searchQuery', e.target.value)}
          className="job-filter-text-input"
        />
      </div>

      {/* Location Filter */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Location</span>
        </label>
        <input
          type="text"
          placeholder="City, Country, or Remote"
          value={filters.location || ''}
          onChange={(e) => onFilterChange('location', e.target.value)}
          className="job-filter-text-input"
        />
      </div>

      {/* Work Type Filter */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Work Type</span>
        </label>
        <select
          className="job-filter-dropdown"
          value={filters.workType || ''}
          onChange={(e) => onFilterChange('workType', e.target.value)}
        >
          <option value="">Select...</option>
          {['remote', 'hybrid', 'full-time', 'part-time', 'freelance', 'contract'].map(type => (
            <option key={type} value={type}>
              {type.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('-')}
            </option>
          ))}
        </select>
      </div>

      {/* Skills Filter */}
      <div className="job-filter-section">
        <label className="job-filter-section-header">
          <span>Skills</span>
        </label>
        <input
          type="text"
          placeholder="e.g., React, Python, Laravel"
          value={filters.skills || ''}
          onChange={(e) => onFilterChange('skills', e.target.value)}
          className="job-filter-text-input"
        />
      </div>

      {/* Search/Apply Button */}
      {onApplyFilters && (
        <div className={`job-filter-section ${isHorizontal ? 'job-filter-apply-section-horizontal' : 'job-filter-apply-section-vertical'}`}>
          {isHorizontal && (
            <label className="job-filter-section-header">
              <span>Search</span>
            </label>
          )}
          <div style={{
            display: 'flex',
            flexDirection: isHorizontal ? 'row' : 'column',
            gap: isHorizontal ? '12px' : '12px',
            width: isHorizontal ? 'auto' : '100%',
            alignItems: isHorizontal ? 'flex-end' : 'stretch'
          }}>
            <button 
              className="job-filters-apply-btn"
              onClick={onApplyFilters}
              style={isHorizontal ? { marginTop: 0, width: 'auto', minWidth: '150px' } : {}}
            >
              {!isHorizontal && (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              )}
              {isHorizontal ? 'Search' : 'Search Talents'}
            </button>
            {hasActiveFilters() && onSavePreference && (
              <button 
                className="job-filters-save-preference-btn"
                onClick={onSavePreference}
                style={{
                  padding: '10px 20px',
                  background: 'transparent',
                  color: '#7a5fb8',
                  border: '1px solid #7a5fb8',
                  borderRadius: '8px',
                  fontSize: isHorizontal ? '13px' : '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  width: isHorizontal ? 'auto' : '100%',
                  justifyContent: 'center',
                  whiteSpace: 'nowrap',
                  minWidth: isHorizontal ? '150px' : 'auto'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f5f3ff';
                  e.target.style.borderColor = '#6b4fa0';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.borderColor = '#7a5fb8';
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                </svg>
                Save as Preference
              </button>
            )}
          </div>
        </div>
      )}

    </div>
  );
};

export default TalentFilters;

